import { ITableColumn } from 'src/components/Table/types';

// Guard against a bare number slipping through an `any`-typed caller: a unitless track (e.g. `220`)
// is invalid CSS and voids the entire grid-template-columns, collapsing the table. Treat numbers as
// pixels so the grid can never be silently broken again.
const toTrackSize = (value: string | number): string =>
  typeof value === 'number' ? `${value}px` : value;

const trackFor = (column: ITableColumn): string => {
  if (column.minWidth && column.width) {
    return `minmax(${toTrackSize(column.minWidth)}, ${toTrackSize(column.width)})`;
  }

  if (column.minWidth) {
    return `minmax(${toTrackSize(column.minWidth)}, 1fr)`;
  }

  if (column.width) {
    return toTrackSize(column.width);
  }

  return '1fr';
};

export const buildColumnTemplate = (columns: ITableColumn[]): string => {
  return columns.map((column: ITableColumn) => trackFor(column)).join(' ');
};

export const buildMinWidth = (columns: ITableColumn[]): string | undefined => {
  const widths: string[] = columns.reduce(
    (acc: string[], column: ITableColumn) => {
      if (column.minWidth || column.width) {
        acc.push(toTrackSize((column.minWidth ?? column.width) as string | number));
      }

      return acc;
    },
    []
  );

  if (widths.length === 0) {
    return undefined;
  }

  return `calc(${widths.join(' + ')})`;
};
